<template>
  <div>
    <div class="text-blue font-weight-bold">选择测点
      <el-checkbox
        :indeterminate="isIndeterminate"
        @change="handleCheckAllChange"
        class="float-right"
        style="margin-right: 30px"
        v-model="checkAll">全选
      </el-checkbox>
    </div>
    <el-row class="border-solid"
            style="height: 45vh;overflow-y: auto;padding: 30px 0 30px 30px;margin: 10px 30px 0 30px">
      <el-checkbox-group @change="handleCheckedChange" size="small" v-model="checkboxList">
        <el-checkbox :key="item.id" :label="item.id" style="min-width: 29%"
                     v-for="item in pointList">{{ item.name }}
        </el-checkbox>
      </el-checkbox-group>
    </el-row>
  </div>
</template>

<script>

export default {
  name: "PointEdit",
  props: ['pointList'],
  data() {
    return {
      checkAll: false, //全选全不选状态
      isIndeterminate: true, //非全选和全不选状态
      checkboxList: [], //测点选择id
    }
  },
  watch: {
    pointList() {
      this.checkboxList = this.pointList.filter(item => item.spaceShow).map(item => item.id)
      this.handleCheckedChange();
    },
    checkboxList() {
      this.$emit('setCheckPoint', this.checkboxList)
    }
  },
  methods: {
    //全选
    handleCheckAllChange(val) {
      let pointIds = this.pointList.map(item => {
        return item.id
      })
      this.checkboxList = val ? pointIds : [];
      this.isIndeterminate = false;
    },
    //复选框选择
    handleCheckedChange() {
      let checkedCount = this.checkboxList.length;
      this.checkAll = checkedCount === this.pointList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.pointList.length;
    },
  }
}
</script>

<style scoped>

</style>
